module.exports = __webpack_public_path__ + "static/img/banner-invite-id.21beefda.png";